import type { ReactNode } from 'react'

interface Props {
  label: string
  onClick: () => void
  children: ReactNode
  disabled?: boolean
  danger?: boolean
}

export default function IconButton({ label, onClick, children, disabled, danger }: Props) {
  return (
    <button
      type="button"
      className={danger ? 'icon-button icon-button--danger' : 'icon-button'}
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={e => {
        e.stopPropagation()
        onClick()
      }}
    >
      {children}
    </button>
  )
}
